// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Password$SmartcutsMacros = require("../../Password.bs.js");
var UserCredential$SmartcutsMacros = require("../../UserCredential.bs.js");
var UserCredential__PasswordCredential$SmartcutsMacros = require("../../UserCredential__PasswordCredential.bs.js");

function t_encode(encoder_value, v) {
  if (v) {
    return [
            "UpdateTo",
            Curry._1(encoder_value, v._0)
          ];
  } else {
    return ["DoNotUpdate"];
  }
}

function t_decode(decoder_value, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DoNotUpdate" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DoNotUpdate */0
                  };
          }
      case "UpdateTo" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(decoder_value, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* UpdateTo */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(stringifyValue, v) {
  if (v) {
    return "UpdateTo(" + (Curry._1(stringifyValue, v._0) + ")");
  } else {
    return "DoNotUpdate";
  }
}

var UpdateOrNot = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(v) {
  if (v.TAG === /* UpdatePassword */0) {
    return [
            "UpdatePassword",
            Password$SmartcutsMacros.t_encode(v._0)
          ];
  } else {
    return [
            "UpdateOAuthProviderCredential",
            Curry._1(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v._0)
          ];
  }
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "UpdateOAuthProviderCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpdateOAuthProviderCredential */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "UpdatePassword" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Password$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpdatePassword */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(v) {
  if (v.TAG === /* UpdatePassword */0) {
    return "UpdatePassword(" + (Password$SmartcutsMacros.obfuscate(v._0) + ")");
  } else {
    return "UpdateOAuthProviderCredential(" + (v._0 + ")");
  }
}

var PasswordOrOAuthUpdate = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function t_encode$2(encoder_otherSecretData, v) {
  return Js_dict.fromArray([
              [
                "passwordOrOAuthDiff",
                t_encode(t_encode$1, v.passwordOrOAuthDiff)
              ],
              [
                "otherSecretDataDiff",
                t_encode(encoder_otherSecretData, v.otherSecretDataDiff)
              ]
            ]);
}

function t_decode$2(decoder_otherSecretData, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var passwordOrOAuthDiff = t_decode(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "passwordOrOAuthDiff"), null));
  if (passwordOrOAuthDiff.TAG === /* Ok */0) {
    var otherSecretDataDiff = t_decode(decoder_otherSecretData, Belt_Option.getWithDefault(Js_dict.get(dict$1, "otherSecretDataDiff"), null));
    if (otherSecretDataDiff.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                passwordOrOAuthDiff: passwordOrOAuthDiff._0,
                otherSecretDataDiff: otherSecretDataDiff._0
              }
            };
    }
    var e = otherSecretDataDiff._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".otherSecretDataDiff" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = passwordOrOAuthDiff._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".passwordOrOAuthDiff" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$2(stringifyOtherSecretData, param) {
  return "{passwordOrOAuthDiff: " + (stringify(stringify$1, param.passwordOrOAuthDiff) + (", otherSecretData: " + (stringify(stringifyOtherSecretData, param.otherSecretDataDiff) + "}")));
}

var WhatToUpdate = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2
};

function updateCredential_decode(decoder_otherSecretData, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var credentialRef = UserCredential$SmartcutsMacros.CredentialRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "credentialRef"), null));
  if (credentialRef.TAG === /* Ok */0) {
    var whatToUpdate = t_decode$2(decoder_otherSecretData, Belt_Option.getWithDefault(Js_dict.get(dict$1, "whatToUpdate"), null));
    if (whatToUpdate.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                credentialRef: credentialRef._0,
                whatToUpdate: whatToUpdate._0
              }
            };
    }
    var e = whatToUpdate._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".whatToUpdate" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = credentialRef._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".credentialRef" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function updateCredential_encode(encoder_otherSecretData, v) {
  return Js_dict.fromArray([
              [
                "credentialRef",
                UserCredential$SmartcutsMacros.CredentialRef.t_encode(v.credentialRef)
              ],
              [
                "whatToUpdate",
                t_encode$2(encoder_otherSecretData, v.whatToUpdate)
              ]
            ]);
}

function t_encode$3(encoder_otherSecretData, v) {
  switch (v.TAG | 0) {
    case /* SaveNewCredential */0 :
        return [
                "SaveNewCredential",
                UserCredential$SmartcutsMacros.WithoutIdWithPasswordAndWithNestedProviderCredentialRef.t_encode(v._0)
              ];
    case /* UpdateCredential */1 :
        return [
                "UpdateCredential",
                updateCredential_encode(encoder_otherSecretData, v._0)
              ];
    case /* DeleteCredential */2 :
        return [
                "DeleteCredential",
                UserCredential$SmartcutsMacros.CredentialRef.t_encode(v._0)
              ];
    
  }
}

function t_decode$3(decoder_otherSecretData, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DeleteCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = UserCredential$SmartcutsMacros.CredentialRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DeleteCredential */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SaveNewCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = UserCredential$SmartcutsMacros.WithoutIdWithPasswordAndWithNestedProviderCredentialRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SaveNewCredential */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "UpdateCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = updateCredential_decode(decoder_otherSecretData, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpdateCredential */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$3(stringifyOtherSecretData, action) {
  switch (action.TAG | 0) {
    case /* SaveNewCredential */0 :
        return "SaveNewCredential(" + (UserCredential$SmartcutsMacros.WithoutIdWithPasswordAndWithNestedProviderCredentialRef.stringify(action._0) + ")");
    case /* UpdateCredential */1 :
        var match = action._0;
        return "UpdateCredential({credentialRef: " + (UserCredential$SmartcutsMacros.CredentialRef.stringify(match.credentialRef) + (", whatToUpdate: " + (stringify$2(stringifyOtherSecretData, match.whatToUpdate) + "})")));
    case /* DeleteCredential */2 :
        return "DeleteCredential(ref=" + (UserCredential$SmartcutsMacros.CredentialRef.stringify(action._0) + ")");
    
  }
}

var ModifyAction = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  updateCredential_encode: updateCredential_encode,
  updateCredential_decode: updateCredential_decode,
  stringify: stringify$3
};

exports.UpdateOrNot = UpdateOrNot;
exports.PasswordOrOAuthUpdate = PasswordOrOAuthUpdate;
exports.WhatToUpdate = WhatToUpdate;
exports.ModifyAction = ModifyAction;
/* UserCredential-SmartcutsMacros Not a pure module */
